(() => {
  "use strict";

  const CARD_BUILD = "20260916disc20";
  if (window.__ybStorefrontSpeedBuild === CARD_BUILD) return;
  window.__ybStorefrontSpeedBuild = CARD_BUILD;

  const CONFIG_URL =
    "https://portal.yambaba.ae/assets/yambaba-storefront-config.json?v=" +
    CARD_BUILD;

  /* Defaults mirror yambaba-storefront-config.json — edit that JSON to customize. */
  const CFG = {
    cardOffers: {
      enabled: true,
      reserveOfferSlotPx: 30,
      showBestsellerTag: true,
      bestsellersUrl:
        "https://portal.yambaba.ae/assets/yambaba-bestsellers.json",
      hideWishlistQuickView: true,
      priceNowColor: "#0071dc",
      priceWasColor: "#9ca3af",
      savePillBg: "#22c55e",
      savePillColor: "#ffffff",
      bestsellerBg: "#ffc400",
      bestsellerText: "#051e41",
      bestsellerLabel: "Best Seller",
      atcBg: "#0071dc",
      atcText: "#ffffff",
      wishlistBorder: "#0071dc",
    },
    categorySlider: {
      mobileSlidesToShow: 4,
      mobileSlidesToScroll: 1,
      mobileCirclePx: 68,
      autoplaySpeedMs: 3800,
      speedMs: 850,
    },
    newsletter: {
      background: "#0071dc",
      buttonText: "#0071dc",
      buttonBackground: "#ffffff",
    },
  };

  /* Reversible: set window.__YB_DISABLE_CARD_OFFERS = true before this script to skip. */
  function offersEnabled() {
    if (window.__YB_DISABLE_CARD_OFFERS === true) return false;
    return CFG.cardOffers.enabled !== false;
  }

  function injectOfferStyles() {
    if (!offersEnabled()) return;
    const existing = document.getElementById("yb-discount-stars-v1");
    if (existing) existing.remove();
    const o = CFG.cardOffers;
    const n = CFG.newsletter;
    const cat = CFG.categorySlider;
    const offerPx = Number(o.reserveOfferSlotPx) || 30;
    const circlePx = Number(cat.mobileCirclePx) || 68;
    const now = o.priceNowColor || "#0071dc";
    const was = o.priceWasColor || "#9ca3af";
    const pillBg = o.savePillBg || "#22c55e";
    const pillFg = o.savePillColor || "#ffffff";
    const bsBg = o.bestsellerBg || "#ffc400";
    const bsFg = o.bestsellerText || "#051e41";
    const atcBg = o.atcBg || "#0071dc";
    const atcFg = o.atcText || "#ffffff";
    const wishBorder = o.wishlistBorder || "#0071dc";
    const newsBg = n.background || "#0071dc";
    const newsBtnBg = n.buttonBackground || "#ffffff";
    const newsBtnFg = n.buttonText || "#0071dc";
    const hideWish =
      o.hideWishlistQuickView !== false
        ? ".product-item .card-product__group-item.card-wishlist,.product-item .card-product__group-item.card-quickview,.product-item .card-wishlist,.product-item .card-quickview,.product-item .scoder-wishlist,.product-item .quickView{display:none!important}"
        : "";
    const css =
      hideWish +
      ".product-item .sale-badge,.product-item .badge.sale-badge,.product-item .yb-sale-badge,.product-item .yb-save-ribbon{display:none!important}" +
      /* Tags row ABOVE image: Best Seller + Save */
      ".product-item .yb-offer-slot{display:flex!important;align-items:center!important;flex-wrap:wrap!important;gap:6px!important;min-height:" +
      offerPx +
      "px!important;margin:0 0 6px!important;padding:0!important;box-sizing:border-box!important}" +
      ".product-item .yb-badge-slot{display:none!important;min-height:0!important;margin:0!important;padding:0!important;height:0!important;overflow:hidden!important}" +
      ".product-item .yb-save-pill{position:static!important;display:inline-flex!important;align-items:center!important;padding:4px 10px!important;border-radius:999px!important;background:" +
      pillBg +
      "!important;color:" +
      pillFg +
      "!important;font-size:11px!important;font-weight:700!important;line-height:1.2!important;white-space:nowrap!important;pointer-events:none!important}" +
      ".product-item .yb-bestseller-tag{display:inline-flex!important;align-items:center!important;padding:4px 10px!important;border-radius:999px!important;background:" +
      bsBg +
      "!important;color:" +
      bsFg +
      "!important;font-size:11px!important;font-weight:700!important;line-height:1.2!important;letter-spacing:0!important;text-transform:none!important;white-space:nowrap!important}" +
      "@media screen and (max-width:767px){.category-slider-main .brand-slider-inner,.brand-slider.category-slider-main .brand-slider-inner{margin:0 -4px!important}.category-slider-main .brand-item,.brand-slider.category-slider-main .brand-item{padding:0 4px!important}.category-slider-main .category-image,.brand-slider.category-slider-main .category-image{max-width:" +
      circlePx +
      "px!important;width:" +
      circlePx +
      "px!important;height:" +
      circlePx +
      "px!important;margin:0 auto 6px!important}.category-slider-main .category-content .title,.brand-slider.category-slider-main .category-content .title{font-size:10px!important;line-height:1.2!important}.category-slider-main .brand-blocks .slick-list,.brand-slider.category-slider-main .brand-blocks .slick-list{margin:0!important}.category-slider-main .category-heading{padding-bottom:12px!important}.category-slider-main .category-heading .title{font-size:20px!important}.product-item .yb-offer-slot{min-height:" +
      Math.max(22, offerPx - 2) +
      "px!important;margin:0 0 4px!important;gap:4px!important}.product-item .yb-save-pill,.product-item .yb-bestseller-tag{font-size:10px!important;padding:3px 8px!important}}" +
      /* Pricing: NOW blue, WAS grey strike — inline like mockup */
      ".product-item .card-price,.product-item .price,.product-item .price__sale{min-width:0!important;max-width:100%!important}" +
      ".product-item .price .price-item,.product-item .price .money,.product-item .card-price .price-item,.product-item .card-price .money{color:" +
      now +
      "!important;font-weight:700!important}" +
      ".product-item .price--on-sale .price__sale{display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;align-items:baseline!important;gap:8px!important;width:100%!important;max-width:100%!important;float:none!important}" +
      ".product-item .price--on-sale .price__sale > dd,.product-item .price--on-sale .price__compare,.product-item .price--on-sale .price__last{display:inline-block!important;float:none!important;margin:0!important;max-width:100%!important}" +
      ".product-item .price--on-sale .price__compare .price-item,.product-item .price--on-sale s.price-item--regular,.product-item .price--on-sale .price__compare .money,.product-item .price--on-sale del .price-item,.product-item .price--on-sale del .money{color:" +
      was +
      "!important;font-weight:500!important;font-size:12px!important;text-decoration:line-through!important;white-space:nowrap!important}" +
      ".product-item .price--on-sale .price-item--sale,.product-item .price--on-sale .price__last .price-item,.product-item .price--on-sale .price__last .money,.product-item .price:not(.price--on-sale) .price-item,.product-item .price:not(.price--on-sale) .money{color:" +
      now +
      "!important;font-weight:700!important;font-size:14px!important;white-space:nowrap!important}" +
      /* ATC + wishlist heart (no Buy Now) */
      ".product-item .card-information,.product-item .card-information__wrapper{display:flex!important;flex-direction:column!important;min-width:0!important;max-width:100%!important;box-sizing:border-box!important}" +
      ".product-item .yb-card-cta{display:grid!important;grid-template-columns:minmax(0,1fr) 40px!important;gap:8px!important;width:100%!important;max-width:100%!important;margin:8px 0 0!important;order:40!important;box-sizing:border-box!important;position:relative!important;z-index:2!important;align-items:stretch!important}" +
      ".product-item .yb-card-cta--single{grid-template-columns:minmax(0,1fr)!important}" +
      ".product-item .yb-card-cta__btn,.product-item .yb-card-cta a.yb-card-cta__btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-width:0!important;min-height:40px!important;font-size:13px!important;font-weight:700!important;padding:8px 10px!important;white-space:nowrap!important;line-height:1.15!important;box-sizing:border-box!important;overflow:visible!important;border-radius:8px!important;border:1px solid " +
      atcBg +
      "!important;background:" +
      atcBg +
      "!important;color:" +
      atcFg +
      "!important;cursor:pointer!important;text-decoration:none!important}" +
      ".product-item .yb-card-cta__wish{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:40px!important;min-width:40px!important;max-width:40px!important;min-height:40px!important;padding:0!important;margin:0!important;border-radius:8px!important;border:1.5px solid " +
      wishBorder +
      "!important;background:#fff!important;color:" +
      wishBorder +
      "!important;cursor:pointer!important;box-sizing:border-box!important}" +
      ".product-item .yb-card-cta__wish svg{width:18px!important;height:18px!important;fill:none!important;stroke:currentColor!important;stroke-width:2!important}" +
      ".product-item .yb-card-cta__wish.is-active{background:#fff5f5!important;color:#e11d48!important;border-color:#e11d48!important}" +
      ".product-item .yb-card-cta__wish.is-active svg{fill:currentColor!important}" +
      ".product-item .yb-star-rating{display:inline-flex!important;align-items:center!important;gap:6px!important;margin:4px 0 2px!important;line-height:1!important;order:3!important}" +
      ".product-item .yb-star-rating__stars{display:inline-flex!important;align-items:center!important;gap:1px!important}" +
      ".product-item .yb-star-rating__star{color:#d7d7d7!important;font-size:13px!important;line-height:1!important}" +
      ".product-item .yb-star-rating__star--on{color:#f5b400!important}" +
      ".product-item .yb-star-rating__count{color:#6b7280!important;font-size:12px!important;font-weight:500!important}" +
      ".product-item .jdgm-preview-badge .jdgm-star,.product-item .spr-icon.spr-icon-star,.product-item .spr-starrating .spr-icon{color:#f5b400!important;font-size:13px!important}" +
      ".product-item .yb-star-rating--empty,.product-item .yb-star-rating--source-hidden{display:none!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}" +
      ".product-item .card-title{order:1!important}.product-item .card-price,.product-item .price{order:2!important}" +
      ".section-newsletter .newsletter-section,.newsletter-section{background:" +
      newsBg +
      "!important}" +
      ".section-newsletter .newsletter-title,.newsletter-section .newsletter-title,.section-newsletter .newsletter-description,.newsletter-section .newsletter-description{color:#fff!important}" +
      ".section-newsletter .newsletter-section .button,.newsletter-section .button{background:" +
      newsBtnBg +
      "!important;border-color:" +
      newsBtnBg +
      "!important;color:" +
      newsBtnFg +
      "!important}" +
      ".section-newsletter .newsletter-section .button:hover,.newsletter-section .button:hover{background:" +
      newsBtnBg +
      "!important;border-color:" +
      newsBtnBg +
      "!important;color:#111!important}" +
      ".section-newsletter .newsletter-section .field input,.newsletter-section .field input{background:#fff!important;border:1px solid #fff!important}" +
      "@media screen and (max-width:767px){.product-item .price--on-sale .price__compare .price-item,.product-item .price--on-sale s.price-item--regular{font-size:11px!important}.product-item .price--on-sale .price-item--sale,.product-item .price--on-sale .price__last .price-item,.product-item .price:not(.price--on-sale) .price-item{font-size:13px!important}.product-item .yb-card-cta{grid-template-columns:minmax(0,1fr) 36px!important;gap:6px!important;margin-top:6px!important}.product-item .yb-card-cta__btn,.product-item .yb-card-cta a.yb-card-cta__btn{min-height:36px!important;font-size:12px!important;padding:6px 8px!important}.product-item .yb-card-cta__wish{width:36px!important;min-width:36px!important;max-width:36px!important;min-height:36px!important}.product-item .yb-card-cta__wish svg{width:16px!important;height:16px!important}.section-newsletter .newsletter-section,.newsletter-section{padding-top:40px!important;padding-bottom:40px!important;margin-top:40px!important}}";
    const style = document.createElement("style");
    style.id = "yb-discount-stars-v1";
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }
  injectOfferStyles();

  function applyRemoteConfig(data) {
    if (!data || typeof data !== "object") return;
    if (data.cardOffers) Object.assign(CFG.cardOffers, data.cardOffers);
    if (data.categorySlider) Object.assign(CFG.categorySlider, data.categorySlider);
    if (data.newsletter) Object.assign(CFG.newsletter, data.newsletter);
    injectOfferStyles();
    bestsellerCache = null;
    bestsellerLoading = null;
    try {
      document.querySelectorAll(".product-item[data-yb-bestseller]").forEach((el) => {
        el.removeAttribute("data-yb-bestseller");
      });
      document.querySelectorAll(".product-item[data-yb-offer-ui]").forEach((el) => {
        el.removeAttribute("data-yb-offer-ui");
      });
    } catch (_) {
      /* optional */
    }
    try {
      polishProductCards();
      fixCategorySliders();
    } catch (_) {
      /* early fetch before function init is fine; later runs cover it */
    }
  }

  fetch(CONFIG_URL, { credentials: "omit", cache: "no-cache" })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (data) applyRemoteConfig(data);
    })
    .catch(() => {
      /* keep defaults */
    });
  function hideImageLazyLoaders() {
    document.querySelectorAll(".data-lazy-loading").forEach((node) => {
      node.style.setProperty("display", "none", "important");
      node.style.setProperty("width", "0", "important");
      node.style.setProperty("height", "0", "important");
      node.style.setProperty("background", "none", "important");
    });
  }

  function closeSearchDropdown() {
    const focused = document.activeElement?.closest?.("details.search_details");
    document
      .querySelectorAll(
        "#shopify-section-header-02 details.search_details .search-modal.quickSearch, #shopify-section-header-02 details.search_details summary .quickSearchResultsWrap, #shopify-section-header-02 details.search_details summary .predictive-search--header",
      )
      .forEach((node) => {
        if (focused && focused.contains(node)) return;
        node.style.setProperty("display", "none", "important");
      });
  }

  function removeStuckLoader() {
    const leftover = document.getElementById("yb-page-loader");
    if (leftover) leftover.remove();
  }

  function cleanSrcset(srcset) {
    return String(srcset || "")
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean)
      .join(", ");
  }

  function pickLazyUrl(srcset, dataSrc) {
    const parts = String(srcset || "")
      .split(",")
      .map((part) => part.trim().split(/\s+/)[0])
      .filter(Boolean);
    const master = parts.find(
      (url) =>
        /\/files\/[^/?]+?\.(?:png|jpe?g|webp)(?:\?|$)/i.test(url) &&
        !/_\d+x\./.test(url),
    );
    const preferred =
      master ||
      parts.find((url) => /_(720|750|940|960)x\./.test(url)) ||
      parts[Math.min(1, Math.max(0, parts.length - 1))] ||
      parts[0] ||
      dataSrc ||
      "";
    if (!preferred) return "";
    return preferred.startsWith("//") ? `https:${preferred}` : preferred;
  }

  function hydrateImage(img, opts) {
    if (!img || img.getAttribute("data-yb-hydrated") === "1") return;
    const srcsetRaw =
      img.getAttribute("data-srcset") || img.getAttribute("srcset") || "";
    const dataSrc = img.getAttribute("data-src") || "";
    const cleaned = cleanSrcset(srcsetRaw);
    const url = pickLazyUrl(cleaned, dataSrc);
    if (!url && !img.getAttribute("src")) return;
    if (url && !img.getAttribute("src")) img.setAttribute("src", url);
    if (cleaned) {
      if (!img.getAttribute("srcset") || img.hasAttribute("data-srcset")) {
        img.setAttribute("srcset", cleaned);
      }
    }
    img.removeAttribute("data-src");
    img.removeAttribute("data-srcset");
    img.classList.remove("lazyload", "lazyloading");
    img.classList.add("lazyloaded");
    img.setAttribute("data-yb-hydrated", "1");
    if (opts && opts.eager) {
      img.setAttribute("loading", "eager");
      img.setAttribute("fetchpriority", "high");
      img.setAttribute("decoding", "async");
    }
  }

  function hydrateHeroFirst() {
    document
      .querySelectorAll(
        '[id*="__yb_hero_fullwidth_slider"] img, #shopify-section-yb_hero_fullwidth_slider img, .sections-slide-show .slideshow-slider img, .sections-slide-show .slide-grid img, .sections-slide-show .slide-grid-left img, .sections-slide-show .slide-grid-right img, .slide-show .slide-grid img',
      )
      .forEach((img) => hydrateImage(img, { eager: true }));
  }

  function hydrateLazyImages() {
    hydrateHeroFirst();
    document
      .querySelectorAll("img.lazyload, img[data-srcset], img[data-src]")
      .forEach((img) => hydrateImage(img, { eager: false }));
  }

  function initLazySizes() {
    try {
      if (window.lazySizesConfig) window.lazySizesConfig.init = true;
      if (window.lazySizes && typeof window.lazySizes.init === "function") {
        window.lazySizes.init();
      }
    } catch (_) {
      /* optional */
    }
  }

  function decodeProductJson(raw) {
    if (!raw) return null;
    try {
      const text = String(raw)
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, "&");
      return JSON.parse(text);
    } catch (_) {
      return null;
    }
  }

  function productHasRealVariants(product) {
    if (!product) return false;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (variants.length > 1) return true;
    const options = Array.isArray(product.options) ? product.options : [];
    const meaningfulOptions = options.filter((opt) => {
      const name = String(opt || "")
        .trim()
        .toLowerCase();
      return name && name !== "title" && name !== "default title";
    });
    if (meaningfulOptions.length > 0 && variants.length > 0) {
      const title = String(variants[0].title || "").trim().toLowerCase();
      return title !== "default title";
    }
    return false;
  }

  function productUrl(card, product) {
    const fromTitle = card.querySelector(
      ".card-title[href], a.card-title, a.card-media",
    );
    const href = fromTitle?.getAttribute("href") || "";
    if (href) return href;
    if (product?.handle) return `/products/${product.handle}`;
    return "#";
  }

  function firstAvailableVariant(product) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return variants.find((v) => v && v.available !== false) || variants[0] || null;
  }

  async function addVariantToCart(variantId, quantity) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity || 1 }],
      }),
    });
    if (!res.ok) {
      const errText = await res.text().catch(() => "");
      throw new Error(errText || `Add to cart failed (${res.status})`);
    }
    return res.json();
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));
    if (typeof window.refreshCart === "function") {
      try {
        window.refreshCart();
      } catch (_) {
        /* optional */
      }
    }
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    if (busy) btn.setAttribute("aria-busy", "true");
    else btn.removeAttribute("aria-busy");
  }

  function parseMoneyCents(text) {
    if (!text) return NaN;
    const cleaned = String(text).replace(/[^\d.,]/g, "").replace(/,/g, "");
    const n = Number.parseFloat(cleaned);
    return Number.isFinite(n) ? Math.round(n * 100) : NaN;
  }

  function formatAed(cents) {
    const v = Math.max(0, Math.round(cents) / 100);
    return (
      "AED " +
      v.toLocaleString("en-AE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  function cardSaleAmounts(card) {
    const product = decodeProductJson(card.getAttribute("data-json-product"));
    const variant =
      firstAvailableVariant(product) || product?.variants?.[0] || null;
    let price =
      typeof variant?.price === "number" ? variant.price : NaN;
    let compare =
      typeof variant?.compare_at_price === "number"
        ? variant.compare_at_price
        : NaN;

    if (!Number.isFinite(price) || !Number.isFinite(compare) || compare <= price) {
      const saleText =
        card.querySelector(".price-item--sale")?.textContent ||
        card.querySelector(".price__sale .price__last .price-item")
          ?.textContent ||
        "";
      const compareText =
        card.querySelector(".price__compare .price-item")?.textContent ||
        card.querySelector("s.price-item--regular")?.textContent ||
        "";
      if (!Number.isFinite(price)) price = parseMoneyCents(saleText);
      if (!Number.isFinite(compare)) compare = parseMoneyCents(compareText);
    }

    if (
      !Number.isFinite(price) ||
      !Number.isFinite(compare) ||
      compare <= price ||
      price < 0
    ) {
      return null;
    }
    const save = compare - price;
    const pct = Math.round((save / compare) * 100);
    if (save <= 0 || pct <= 0) return null;
    return { price, compare, save, pct };
  }

  function ensureSaleBadge(card, pct) {
    let badge = card.querySelector(".sale-badge, .badge.sale-badge");
    const host =
      card.querySelector(".scoder-productBadges, .card__badge") ||
      card.querySelector(".card-product__wrapper, .card.ajax-loaded, .card");
    if (!badge && host) {
      const wrap =
        host.classList?.contains("scoder-productBadges") ||
        host.classList?.contains("card__badge")
          ? host
          : (() => {
              const el = document.createElement("div");
              el.className =
                "card__badge badge-left scoder-productBadges scoder-productBadges--left yb-sale-badge-wrap";
              host.prepend(el);
              return el;
            })();
      badge = document.createElement("span");
      badge.className = "badge sale-badge";
      badge.setAttribute("aria-hidden", "true");
      wrap.appendChild(badge);
    }
    if (badge) {
      badge.textContent = "-" + pct + "%";
      badge.classList.add("yb-sale-badge");
    }
  }

  function ensureOfferSlot(card) {
    const cardRoot =
      card.querySelector(":scope > .card") || card.querySelector(".card") || card;
    let slot = card.querySelector(".yb-offer-slot");
    if (!slot) {
      slot = document.createElement("div");
      slot.className = "yb-offer-slot";
      const media =
        cardRoot.querySelector(".card-product") ||
        cardRoot.querySelector(".card-product__wrapper") ||
        cardRoot.querySelector(".card-media");
      if (media && media.parentElement === cardRoot) {
        cardRoot.insertBefore(slot, media);
      } else {
        cardRoot.insertBefore(slot, cardRoot.firstChild);
      }
    }
    return slot;
  }

  function ensureBadgeSlot(card) {
    let slot = card.querySelector(".yb-badge-slot");
    if (slot) return slot;
    slot = document.createElement("div");
    slot.className = "yb-badge-slot";
    const media =
      card.querySelector(".card-product") ||
      card.querySelector(".card-product__wrapper") ||
      card.querySelector(".card-media");
    const info =
      card.querySelector(".card-information") ||
      card.querySelector(".card-information__wrapper");
    if (media && media.parentElement) {
      if (info && info.parentElement === media.parentElement) {
        media.parentElement.insertBefore(slot, info);
      } else {
        media.insertAdjacentElement("afterend", slot);
      }
    } else if (info) {
      info.insertAdjacentElement("beforebegin", slot);
    } else {
      card.appendChild(slot);
    }
    return slot;
  }

  function placeSavePill(card, amounts) {
    if (!card) return;
    const slot = ensureOfferSlot(card);

    card.querySelectorAll(".yb-save-ribbon").forEach((el) => el.remove());
    card
      .querySelectorAll(".sale-badge, .badge.sale-badge, .yb-sale-badge")
      .forEach((el) => {
        el.classList.add("yb-sale-badge");
        el.setAttribute("aria-hidden", "true");
        el.style.setProperty("display", "none", "important");
      });

    let pill = slot.querySelector(".yb-save-pill") || card.querySelector(".yb-save-pill");
    if (!amounts) {
      if (pill) pill.remove();
      return;
    }

    const label = "Save " + formatAed(amounts.save);
    if (!pill) {
      pill = document.createElement("div");
      pill.className = "yb-save-pill";
    }
    pill.textContent = label;
    pill.setAttribute("aria-hidden", "true");
    if (pill.parentElement !== slot) slot.appendChild(pill);
  }

  let bestsellerCache = null;
  let bestsellerLoading = null;

  function loadBestsellers() {
    if (bestsellerCache) return Promise.resolve(bestsellerCache);
    if (bestsellerLoading) return bestsellerLoading;
    const baseUrl =
      CFG.cardOffers.bestsellersUrl ||
      "https://portal.yambaba.ae/assets/yambaba-bestsellers.json";
    const url =
      baseUrl + (baseUrl.includes("?") ? "&" : "?") + "v=" + CARD_BUILD;
    bestsellerLoading = fetch(url, { credentials: "omit", cache: "no-cache" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const handles = new Set(
          (data?.handles || []).map((h) => String(h || "").toLowerCase()),
        );
        const ids = new Set((data?.ids || []).map((id) => String(id || "")));
        bestsellerCache = { handles, ids };
        return bestsellerCache;
      })
      .catch(() => {
        bestsellerCache = { handles: new Set(), ids: new Set() };
        return bestsellerCache;
      });
    return bestsellerLoading;
  }

  function cardProductIdentity(card) {
    const product = decodeProductJson(card.getAttribute("data-json-product"));
    const handle =
      (product?.handle && String(product.handle).toLowerCase()) ||
      card
        .querySelector("a[href*='/products/']")
        ?.getAttribute("href")
        ?.split("/products/")[1]
        ?.split("?")[0]
        ?.split("#")[0]
        ?.toLowerCase() ||
      "";
    const id = product?.id != null ? String(product.id).replace(/\D/g, "") : "";
    return { handle, id, product };
  }

  function enhanceBestSeller(card) {
    if (!card || card.getAttribute("data-yb-bestseller") === "1") return;
    if (CFG.cardOffers.showBestsellerTag === false) {
      card.setAttribute("data-yb-bestseller", "1");
      return;
    }
    const slot = ensureOfferSlot(card);
    const { handle, id } = cardProductIdentity(card);

    const apply = (isBest) => {
      card.setAttribute("data-yb-bestseller", "1");
      let tag = slot.querySelector(".yb-bestseller-tag");
      if (!isBest) {
        if (tag) tag.remove();
        return;
      }
      if (!tag) {
        tag = document.createElement("span");
        tag.className = "yb-bestseller-tag";
        tag.textContent = CFG.cardOffers.bestsellerLabel || "Best Seller";
        /* Best Seller first, then Save pill */
        slot.insertBefore(tag, slot.firstChild);
      }
    };

    /* Instant: existing theme badge/text */
    const existing = (card.textContent || "").toLowerCase();
    if (/\bbest\s*seller\b/.test(existing) && card.querySelector(".badge, .product-badge, .scoder-productBadges")) {
      /* fall through to async list for accuracy */
    }

    loadBestsellers().then((cache) => {
      const hit =
        (handle && cache.handles.has(handle)) ||
        (id && cache.ids.has(id));
      apply(Boolean(hit));
    });
  }

  function enhanceCardOffers(card) {
    if (!offersEnabled() || !card) return;
    if (card.getAttribute("data-yb-offer-ui") === "3") return;
    if (card.querySelector(".card-title")?.textContent?.includes("Example product")) {
      card.setAttribute("data-yb-offer-ui", "3");
      return;
    }

    ensureOfferSlot(card);

    const amounts = cardSaleAmounts(card);
    if (amounts) {
      card.classList.add("yb-has-discount");
      placeSavePill(card, amounts);
    } else {
      card.classList.remove("yb-has-discount");
      placeSavePill(card, null);
      card.querySelectorAll(".yb-save-ribbon").forEach((el) => el.remove());
    }

    enhanceBestSeller(card);
    enhanceCardStars(card);
    card.setAttribute("data-yb-offer-ui", "3");
  }

  function parseReviewFromCard(card) {
    const reviewRoot = card.querySelector(
      ".scoder-productReview, .card-review, .jdgm-preview-badge, .shopify-product-reviews-badge",
    );
    if (!reviewRoot) return null;

    const attrScore =
      reviewRoot.getAttribute("data-average-rating") ||
      reviewRoot.getAttribute("data-rating") ||
      reviewRoot.querySelector("[data-score], [data-average-rating], [data-rating]")
        ?.getAttribute("data-score") ||
      reviewRoot
        .querySelector("[data-score], [data-average-rating], [data-rating]")
        ?.getAttribute("data-average-rating") ||
      reviewRoot
        .querySelector("[data-score], [data-average-rating], [data-rating]")
        ?.getAttribute("data-rating");

    const text = (reviewRoot.textContent || "").replace(/\s+/g, " ").trim();
    const countMatch = text.match(/\((\d+)\)/) || text.match(/(\d+)\s*reviews?/i);
    const scoreMatch =
      text.match(/([\d.]+)\s*\/\s*5/) || text.match(/([\d.]+)\s*out of\s*5/i);

    let score = Number.parseFloat(attrScore || "");
    if (!Number.isFinite(score) && scoreMatch) {
      score = Number.parseFloat(scoreMatch[1]);
    }
    let count = countMatch ? Number.parseInt(countMatch[1], 10) : NaN;

    const filledStars = reviewRoot.querySelectorAll(
      ".jdgm-star.jdgm--on, .spr-icon-star, .icon--star-filled, .star--filled",
    ).length;
    if (!Number.isFinite(score) && filledStars > 0) score = filledStars;

    if (!Number.isFinite(score) || score <= 0) return null;
    if (!Number.isFinite(count) || count < 0) count = 0;
    return { score: Math.min(5, Math.max(0, score)), count };
  }

  function formatReviewCount(count) {
    const n = Number(count) || 0;
    if (n >= 10000) return Math.round(n / 1000) + "K";
    if (n >= 1000) {
      const v = (n / 1000).toFixed(1);
      return (v.endsWith(".0") ? v.slice(0, -2) : v) + "K";
    }
    return String(n);
  }

  function enhanceCardStars(card) {
    if (card.querySelector(".yb-star-rating")) return;

    const title = card.querySelector(".card-title");
    const priceEl =
      card.querySelector(".card-price, .price") ||
      card.querySelector(".card-information .price");
    const reviewSlot =
      card.querySelector(".scoder-productReview, .card-review") || null;

    const parsed = parseReviewFromCard(card);
    if (!parsed) {
      if (reviewSlot) reviewSlot.classList.add("yb-star-rating--empty");
      return;
    }

    const row = document.createElement("div");
    row.className = "yb-star-rating";
    row.setAttribute(
      "aria-label",
      parsed.score.toFixed(1) + " out of 5 stars, " + parsed.count + " reviews",
    );

    const stars = document.createElement("span");
    stars.className = "yb-star-rating__stars";
    stars.setAttribute("aria-hidden", "true");
    const filled = Math.max(1, Math.min(5, Math.round(parsed.score)));
    let i = 0;
    for (; i < 5 && i < 8; i += 1) {
      const s = document.createElement("span");
      s.className =
        "yb-star-rating__star" +
        (i < filled ? " yb-star-rating__star--on" : "");
      s.textContent = "★";
      stars.appendChild(s);
    }

    const countEl = document.createElement("span");
    countEl.className = "yb-star-rating__count";
    countEl.textContent = "(" + formatReviewCount(parsed.count) + ")";

    row.appendChild(stars);
    row.appendChild(countEl);

    if (priceEl && priceEl.parentElement) {
      priceEl.insertAdjacentElement("afterend", row);
    } else if (title && title.parentElement) {
      title.insertAdjacentElement("afterend", row);
    } else if (reviewSlot) {
      reviewSlot.insertAdjacentElement("afterend", row);
    }

    if (reviewSlot) {
      reviewSlot.classList.add("yb-star-rating--source-hidden");
      reviewSlot.classList.remove("yb-star-rating--empty");
    }
  }

  function makeWishlistButton(card) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "yb-card-cta__wish";
    btn.setAttribute("aria-label", "Add to wishlist");
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-6.7-4.35-9.33-7.4C.8 11.4.5 8.7 2.1 6.9 3.5 5.3 5.9 5 7.6 6.2c.7.5 1.3 1.2 1.9 2 .6-.8 1.2-1.5 1.9-2 1.7-1.2 4.1-.9 5.5.7 1.6 1.8 1.3 4.5-.57 6.7C18.7 16.65 12 21 12 21z"/></svg>';
    btn.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      const themeWish =
        card.querySelector(
          ".card-wishlist a, .card-wishlist button, .card-product__group-item.card-wishlist a, .card-product__group-item.card-wishlist button, a.wishlist, button.wishlist, [data-wishlist], .wishlist-btn",
        ) || null;
      if (themeWish && typeof themeWish.click === "function") {
        themeWish.click();
        btn.classList.add("is-active");
        return;
      }
      window.location.assign("/pages/wishlist");
    });
    return btn;
  }

  function polishCard(card) {
    if (!card) return;
    if (card.getAttribute("data-yb-card-polished") === "3") {
      enhanceCardOffers(card);
      return;
    }

    /* Rebuild older ATC/Buy CTAs to mockup ATC + wishlist */
    card.querySelectorAll(".yb-card-cta").forEach((el) => el.remove());
    card.removeAttribute("data-yb-offer-ui");

    enhanceCardOffers(card);
    const chooseWrap = card.querySelector(".product-button-choose-option");
    if (!chooseWrap) {
      card.setAttribute("data-yb-card-polished", "3");
      return;
    }

    const product = decodeProductJson(card.getAttribute("data-json-product"));
    const url = productUrl(card, product);
    const multi = productHasRealVariants(product);
    const cta = document.createElement("div");
    cta.className = "yb-card-cta";

    if (multi) {
      const link = document.createElement("a");
      link.className = "yb-card-cta__btn yb-card-cta__pdp";
      link.href = url;
      link.textContent = "View product";
      cta.appendChild(link);
      cta.appendChild(makeWishlistButton(card));
    } else {
      const variant = firstAvailableVariant(product);
      const variantId =
        variant?.id ||
        card.querySelector('form[action*="/cart/add"] input[name="id"]')
          ?.value ||
        "";

      const atc = document.createElement("button");
      atc.type = "button";
      atc.className = "yb-card-cta__btn yb-card-cta__atc";
      atc.textContent = "Add to Cart";
      atc.setAttribute("data-yb-label-full", "Add to Cart");
      atc.setAttribute("data-yb-label-short", "Add to Cart");

      if (!variantId) {
        atc.textContent = "View product";
        atc.setAttribute("data-yb-label-full", "View product");
        atc.setAttribute("data-yb-label-short", "View product");
        atc.addEventListener("click", () => {
          window.location.assign(url);
        });
      } else {
        atc.addEventListener("click", async () => {
          setBusy(atc, true);
          try {
            const existingBtn = card.querySelector(
              'form[action*="/cart/add"] button[name="add"], .button-ATC',
            );
            if (existingBtn && typeof existingBtn.click === "function") {
              existingBtn.click();
            } else {
              await addVariantToCart(variantId, 1);
              refreshCartUi();
            }
          } catch (error) {
            console.warn("[YamBaba] Add to cart failed", error);
            window.location.assign(url);
          } finally {
            setBusy(atc, false);
          }
        });
      }

      cta.appendChild(atc);
      cta.appendChild(makeWishlistButton(card));
    }

    chooseWrap.classList.add("yb-card-cta-replaced");
    const info =
      card.querySelector(".card-information") ||
      card.querySelector(".card-information__wrapper");
    if (info) {
      info.appendChild(cta);
    } else {
      const cardRoot = card.querySelector(":scope > .card") || card;
      cardRoot.appendChild(cta);
    }
    card.setAttribute("data-yb-card-polished", "3");
  }

  function polishProductCards() {
    document
      .querySelectorAll(".product-item")
      .forEach((card) => {
        polishCard(card);
      });
  }

  function softenLeftRightAnimations() {
    document
      .querySelectorAll(
        ".wow.fadeInLeft, .wow.fadeInRight, .fadeInLeft, .fadeInRight, .animation-type-fadeInLeft, .animation-type-fadeInRight",
      )
      .forEach((el) => {
        el.classList.remove("fadeInLeft", "fadeInRight");
        el.classList.add("fadeInUp");
        if (el.className.includes("animation-type-fadeInLeft")) {
          el.className = el.className.replace(
            /animation-type-fadeInLeft/g,
            "animation-type-fadeInUp",
          );
        }
        if (el.className.includes("animation-type-fadeInRight")) {
          el.className = el.className.replace(
            /animation-type-fadeInRight/g,
            "animation-type-fadeInUp",
          );
        }
      });
  }

  function syncCtaLabels() {
    const short = window.innerWidth <= 767;
    document.querySelectorAll(".yb-card-cta__btn[data-yb-label-full]").forEach((btn) => {
      const full = btn.getAttribute("data-yb-label-full");
      const compact = btn.getAttribute("data-yb-label-short") || full;
      const next = short ? compact : full;
      if (btn.textContent !== next) btn.textContent = next;
    });
  }

  function fixCategorySliders() {
    if (typeof window.jQuery !== "function") return;
    const $ = window.jQuery;
    const mobile = window.innerWidth <= 767;
    const cat = CFG.categorySlider;
    const show = Number(cat.mobileSlidesToShow) || 4;
    const scroll = Number(cat.mobileSlidesToScroll) || 1;
    const circlePx = Number(cat.mobileCirclePx) || 68;
    const autoplaySpeed = Number(cat.autoplaySpeedMs) || 3800;
    const speed = Number(cat.speedMs) || 850;
    const roots = document.querySelectorAll(
      ".category-slider-main .brand-blocks, .brand-slider.category-slider-main .brand-blocks",
    );
    let i = 0;
    const max = Math.min(roots.length, 20);
    for (; i < max; i += 1) {
      const el = roots[i];
      const $el = $(el);
      try {
        if (!mobile) {
          if (el.getAttribute("data-yb-cat4") === "1" && $el.hasClass("slick-initialized")) {
            /* leave desktop to theme; only clear our mobile rebuild mark */
          }
          continue;
        }

        if ($el.hasClass("slick-initialized") && el.getAttribute("data-yb-cat4") === "1") {
          const inst = $el.slick("getSlick");
          if (inst && inst.options && Number(inst.options.slidesToShow) === show) {
            $el.slick("setPosition");
            continue;
          }
        }

        /* Theme responsive breakpoints keep forcing 2 slides — rebuild for N + scroll-by-1 */
        if ($el.hasClass("slick-initialized")) {
          try {
            $el.slick("unslick");
          } catch (_) {
            /* ignore */
          }
        }
        if ($el.hasClass("slick-initialized")) continue;

        $el.slick({
          slidesToShow: show,
          slidesToScroll: scroll,
          arrows: false,
          dots: false,
          infinite: true,
          autoplay: true,
          autoplaySpeed: autoplaySpeed,
          speed: speed,
          cssEase: "ease",
          pauseOnHover: true,
          swipeToSlide: true,
          variableWidth: false,
          centerMode: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: show,
                slidesToScroll: scroll,
                arrows: false,
                dots: false,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: show,
                slidesToScroll: scroll,
                arrows: false,
                dots: false,
              },
            },
          ],
        });
        el.setAttribute("data-yb-cat4", "1");
      } catch (_) {
        /* slick optional */
      }
    }

    document
      .querySelectorAll(
        ".category-slider-main .category-image, .brand-slider.category-slider-main .category-image",
      )
      .forEach((imgWrap) => {
        if (!mobile) return;
        imgWrap.style.setProperty("width", circlePx + "px", "important");
        imgWrap.style.setProperty("height", circlePx + "px", "important");
        imgWrap.style.setProperty("max-width", circlePx + "px", "important");
      });
  }

  function fixMobileProductCarousels() {
    if (typeof window.jQuery !== "function") return;
    const $ = window.jQuery;
    const mobile = window.innerWidth <= 767;
    const carousels = document.querySelectorAll(
      ".sections-product-block .products-carousel.slick-initialized, .sections-product-block .productGrid.slick-initialized",
    );
    let i = 0;
    const max = Math.min(carousels.length, 40);
    for (; i < max; i += 1) {
      const el = carousels[i];
      const $el = $(el);
      try {
        if (mobile) {
          $el.slick("slickSetOption", "slidesToShow", 2, false);
          $el.slick("slickSetOption", "slidesToScroll", 1, false);
          $el.slick("slickSetOption", "arrows", false, false);
          $el.slick("slickSetOption", "dots", true, false);
        }
        $el.slick("setPosition");
      } catch (_) {
        /* slick optional */
      }
    }
  }

  function lockHeroHeight() {
    const root =
      document.querySelector('[id*="__yb_hero_fullwidth_slider"]') ||
      document.getElementById("shopify-section-yb_hero_fullwidth_slider");
    if (!root) return;

    /* Beat theme section <style> that offsets content by header height */
    if (!document.getElementById("yb-hero-align-fix")) {
      const style = document.createElement("style");
      style.id = "yb-hero-align-fix";
      style.textContent =
        '[id*="__yb_hero_fullwidth_slider"] .slide-show-content{position:absolute!important;inset:0!important;top:0!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;height:300px!important;transform:none!important;display:flex!important;align-items:center!important;padding:0!important;margin:0!important;z-index:3!important;pointer-events:none!important}' +
        '[id*="__yb_hero_fullwidth_slider"] .slide-show-content>.container{width:100%!important;max-width:none!important;height:100%!important;margin:0!important;padding:0 72px!important;display:flex!important;align-items:center!important;box-sizing:border-box!important}' +
        '[id*="__yb_hero_fullwidth_slider"] .slideshow-content-outer,[id*="__yb_hero_fullwidth_slider"] .slideshow-content-inner{position:static!important;transform:none!important;top:auto!important;left:auto!important;display:flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:center!important;text-align:left!important;width:100%!important;max-width:520px!important;margin:0!important;padding:0!important}' +
        '[id*="__yb_hero_fullwidth_slider"] .slideshow-sub-title,[id*="__yb_hero_fullwidth_slider"] .slideshow-title,[id*="__yb_hero_fullwidth_slider"] .slideshow-description,[id*="__yb_hero_fullwidth_slider"] .slide-show-banner-group,[id*="__yb_hero_fullwidth_slider"] .slideshow-banner-button{position:static!important;transform:none!important;top:auto!important;left:auto!important;float:none!important;display:block!important;text-align:left!important;margin:0 0 8px 0!important;max-width:100%!important}' +
        '[id*="__yb_hero_fullwidth_slider"] .slide-show-banner-group{display:flex!important;justify-content:flex-start!important;margin:0!important}' +
        '[id*="__yb_hero_fullwidth_slider"] .slideshow-banner-button .button,[id*="__yb_hero_fullwidth_slider"] .slide-show-banner-group .button{position:static!important;transform:none!important;display:inline-flex!important;margin:0!important;pointer-events:auto!important}' +
        '@media screen and (max-width:767px){[id*="__yb_hero_fullwidth_slider"] .slide-show-content>.container{padding:0 14px!important}[id*="__yb_hero_fullwidth_slider"] .slideshow-title{font-size:18px!important;line-height:1.2!important}[id*="__yb_hero_fullwidth_slider"] .slideshow-sub-title{font-size:10px!important}[id*="__yb_hero_fullwidth_slider"] .slideshow-description{font-size:12px!important;max-height:2.6em!important;overflow:hidden!important}[id*="__yb_hero_fullwidth_slider"] .slideshow-slider .slick-arrow{display:none!important}}';
      (document.head || document.documentElement).appendChild(style);
    }

    const nodes = root.querySelectorAll(
      ".slideshow-slider, .slideshow-slider .slick-list, .slideshow-slider .slick-track, .slideshow-slider .slick-slide, .slideshow-slider .images-contain, .slideshow-slider .slide-mobile, .slideshow-slider .slide-pc, .slideshow-slider .slide-image, .slideshow-slider img, .slide-show-content",
    );
    let i = 0;
    const max = Math.min(nodes.length, 220);
    for (; i < max; i += 1) {
      const el = nodes[i];
      el.style.setProperty("height", "300px", "important");
      el.style.setProperty("max-height", "300px", "important");
      el.style.setProperty("min-height", "300px", "important");
      el.style.setProperty("padding-top", "0", "important");
      if (el.classList.contains("slide-show-content")) {
        el.style.setProperty("top", "0", "important");
        el.style.setProperty("left", "0", "important");
        el.style.setProperty("transform", "none", "important");
        el.style.setProperty("inset", "0", "important");
      }
      if (el.tagName === "IMG") {
        el.style.setProperty("object-fit", "cover", "important");
        el.style.setProperty("width", "100%", "important");
        el.style.setProperty("opacity", "1", "important");
        el.style.setProperty("visibility", "visible", "important");
        if (!el.getAttribute("src")) {
          const srcset = el.getAttribute("srcset") || el.getAttribute("data-srcset") || "";
          const first = String(srcset).split(",")[0]?.trim().split(/\s+/)[0];
          if (first) el.setAttribute("src", first.startsWith("//") ? "https:" + first : first);
        }
      }
    }
    if (window.innerWidth <= 1024) {
      root.querySelectorAll(".slide-pc").forEach((el) => {
        el.style.setProperty("display", "none", "important");
      });
      root.querySelectorAll(".slide-mobile").forEach((el) => {
        el.style.setProperty("display", "block", "important");
        el.style.setProperty("height", "300px", "important");
      });
      root.querySelectorAll(".slide-show-content > .container").forEach((el) => {
        el.style.setProperty("padding", "0 14px", "important");
      });
    }

    root.querySelectorAll(
      ".slideshow-title, .slideshow-sub-title, .slideshow-description, .slideshow-banner-button, .slide-show-banner-group, .slideshow-content-inner, .slideshow-content-outer",
    ).forEach((el) => {
      el.style.setProperty("position", "static", "important");
      el.style.setProperty("transform", "none", "important");
      el.style.setProperty("top", "auto", "important");
      el.style.setProperty("left", "auto", "important");
      el.style.setProperty("text-align", "left", "important");
      el.style.setProperty("float", "none", "important");
    });
  }

  let polishing = false;
  function run() {
    if (polishing) return;
    polishing = true;
    try {
      hideImageLazyLoaders();
      closeSearchDropdown();
      removeStuckLoader();
      initLazySizes();
      hydrateLazyImages();
      softenLeftRightAnimations();
      lockHeroHeight();
      polishProductCards();
      syncCtaLabels();
      fixMobileProductCarousels();
      fixCategorySliders();
    } finally {
      polishing = false;
    }
  }

  run();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  }
  window.addEventListener("load", run, { once: true });
  setTimeout(run, 50);
  setTimeout(run, 400);
  setTimeout(run, 1200);
  /* Theme slick often boots late — re-apply 4-up category layout a few times */
  setTimeout(fixCategorySliders, 900);
  setTimeout(fixCategorySliders, 1800);
  setTimeout(fixCategorySliders, 3200);
  setTimeout(lockHeroHeight, 600);
  setTimeout(lockHeroHeight, 1500);
  setTimeout(lockHeroHeight, 2800);

  let moTimer = 0;
  let moRuns = 0;
  const MO_MAX_RUNS = 80;
  const observer = new MutationObserver(() => {
    if (polishing || moRuns >= MO_MAX_RUNS) return;
    if (moTimer) window.clearTimeout(moTimer);
    moTimer = window.setTimeout(() => {
      moTimer = 0;
      if (polishing || moRuns >= MO_MAX_RUNS) return;
      moRuns += 1;
      polishing = true;
      try {
        softenLeftRightAnimations();
        polishProductCards();
      } finally {
        polishing = false;
      }
    }, 200);
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        observer.observe(document.body, { childList: true, subtree: true });
      },
      { once: true },
    );
  }
})();
